<template>
  <div id="app" v-if="isLoggedIn">
    <navbar :show="true"></navbar>
    <sidebar :show="sidebar.opened && !sidebar.hidden"></sidebar>
    <container-main></container-main>
  </div>
  <div id="app" v-else>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import '@/components/container-main'

export default {
  name: 'app',
  beforeMount () {
    const { body } = document
    const WIDTH = 768
    const RATIO = 3

    const handler = () => {
      if (!document.hidden) {
        let rect = body.getBoundingClientRect()
        let isMobile = rect.width - RATIO < WIDTH
        this.toggleDevice(isMobile ? 'mobile' : 'other')
        this.toggleSidebar(!isMobile)
      }
    }

    document.addEventListener('visibilitychange', handler)
    window.addEventListener('DOMContentLoaded', handler)
    window.addEventListener('resize', handler)
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'isLoggedIn'
    ])
  },
  methods: mapActions([
    'toggleDevice',
    'toggleSidebar'
  ])
}
</script>

<style lang="scss">
//@import url('https://fonts.googleapis.com/css?family=Raleway:400,700');
@import '~animate.css';
.animated {
  animation-duration: .377s;
}

$family-primary: 'Raleway', sans-serif;
@import '~bulma';

$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome';

$simple-line-font-path: '~simple-line-icons/fonts/';
@import '~simple-line-icons/scss/simple-line-icons';

$piscicultura_color: #005bcc;
$facebook_color: #3B5998;
$google_color: #D34836;
$linkedin_color: #0E76A8;

html, body {
  // background-color: whitesmoke;
  font-size: 14px;
  padding: 0;
  margin: 0;
  min-height: 100vh;
}

.columns-withpadding {
  padding: 0;
}
#image-background {
  padding: 0.75rem 0.75rem 0 0.75rem;
}
button, a {
  &.is-outlined {
    &.is-piscicultura {
      background-color: white;
      color: $piscicultura_color;
      border: 1px solid $piscicultura_color;
      &:hover, &:active, &:focus  {
        background-color: $piscicultura_color;
        color: white;
      }
    }
    &.is-facebook {
      background-color: white;
      color: $facebook_color;
      border: 1px solid $facebook_color;
      &:hover, &:active, &:focus  {
        background-color: $facebook_color;
        color: white;
      }
    }
    &.is-google {
      background-color: white;
      color: $google_color;
      border: 1px solid $google_color;
      &:hover, &:active, &:focus  {
        background-color: $google_color;
        color: white;
      }
    }
    &.is-linkedin {
      background-color: white;
      color: $linkedin_color;
      border: 1px solid $linkedin_color;
      &:hover, &:active, &:focus  {
        background-color: $linkedin_color;
        color: white;
      }
    }
  }
  &.is-piscicultura {
    background-color: $piscicultura_color;
    color: white;
    opacity: .9;
    &:hover, &:active, &:focus  {
      color: white;
      opacity: 1;
    }
  }
  &.is-facebook {
    background-color: $facebook_color;
    color: white;
    opacity: .9;
    &:hover, &:active, &:focus  {
      color: white;
      opacity: 1;
    }
  }
  &.is-google {
    background-color: $google_color;
    color: white;
    opacity: .9;
    &:hover, &:active, &:focus  {
      color: white;
      opacity: 1;
    }
  }
  &.is-linkedin {
    background-color: $linkedin_color;
    color: white;
    opacity: .9;
    &:hover, &:active, &:focus  {
      color: white;
      opacity: 1;
    }
  }
}

.card-header {
  background-color: #0b3b6b;
  .card-header-title {
    color: #fff;
  }
}

a {
  color: #3273dc;
  &:hover {
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?1503e930